import React from 'react';
import groupThumbnail from '../../../assets/img/group-imgs/group-pic1.png';
import membersIcon from '../../../assets/img/group-imgs/members.svg'

const GroupInvitePosts = () => {
    const groupInvitePosts = [
        {
            groupName: 'Fluter Learn',
            groupDescription: 'Fluter Learn condimentu, pharetra el...',
            groupMembers : '2.5k members',
            groupThumbnail: groupThumbnail
        },
        {
            groupName: 'python Learn',
            groupDescription: 'python Learn condimentu, pharetra el...',
            groupMembers : '5k members',
            groupThumbnail: groupThumbnail
        },
        {
            groupName: 'Node JS Learn',
            groupDescription: 'Node JS Learn condimentu, pharetra el...',
            groupMembers : '3k members',
            groupThumbnail: groupThumbnail
        },
        {
            groupName: 'Etical Haking',
            groupDescription: 'Etical Haking condimentu, pharetra el...',
            groupMembers : '4k members',
            groupThumbnail: groupThumbnail
        },
        {
            groupName: 'React Js Learn',
            groupDescription: 'React Js Learn condimentu, pharetra el...',
            groupMembers : '1.0k members',
            groupThumbnail: groupThumbnail
        },
    ]
    return (
        <div className="row gy-4">
            {
                groupInvitePosts.map(( item, index)=><div className="col-12 col-md-6 col-xxl-4" key={index}>
                <div className="card" style={{backgroundColor: "#171717", borderRadius: "20px",borderStyle: "none"}}>
                    <div>
                        <img className="w-100" src={item.groupThumbnail} style={{borderRadius: "20px 20px 0px 0px"}} alt='' />
                    </div>
                    <div className="card-body">
                        <div className="row gap-2">
                            <div className="col-12">
                                <span className="grp_h">{item.groupName}</span>
                            </div>
                            <div className="col-12">
                                <p className="mb-0 l_para">{item.groupDescription}</p>
                            </div>
                            <div className="col-12">
                                <img className="me-2" src={membersIcon} alt='' />
                                <span className="grp_mem">{item.groupMembers}</span></div>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12">
                                        <button className="custm-pill-button-small rounded-pill px-3 py-2 post_btn d-flex align-items-center w-100" type="button">Join</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> )
            }
            
        </div>
    );
};

export default GroupInvitePosts;